
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mortgage-brokers/[slug]",
      function () {
        return require("private-next-pages/mortgage-brokers/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mortgage-brokers/[slug]"])
      });
    }
  